const SIZES = {
  NAME: 33,
  ACTIVE: 33,
  TESTING: 33,
};

export default SIZES;
